import type {LinkField, KeyTextField, ImageField, VideoOEmbed, EmbedField} from '@prismicio/types';
import {usePrismicTypeGuards} from './useTypeGuards';

const {hasProperty, isFilled} = usePrismicTypeGuards();

function isLink(textLink: KeyTextField, link?: LinkField | null): boolean {
    return !!link && link.link_type !== 'Any' && textLink !== null;
}

function hasLessThanTwoLabels(labels: (string | null)[]) {
    return labels.filter((label) => label !== null).length < 2;
}

function hasText(value: unknown) {
    return hasProperty(value, 'text') && isFilled(value.text);
}

function hasObjectField(field: ImageField | VideoOEmbed | EmbedField) {
    return field && JSON.stringify(field) !== '{}';
}

function createPrismicFieldHelpers() {
    return {
        hasObjectField,
        hasLessThanTwoLabels,
        isLink,
        hasText,
    };
}

export {createPrismicFieldHelpers as usePrismicFieldHelpers};
